module.exports = __webpack_public_path__ + "static/assets/5d2d256b465345ebd2b47a76534b185a.png";